export default __webpack_public_path__ + "static/media/organic_market_preview.8a2ce75f.png";